import { Search } from 'lucide-react'
import { type InputHTMLAttributes } from 'react'
import styles from './SearchField.module.css'

type SearchFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> & {
  inputClassName?: string
  size?: 'default' | 'mobile'
}

export const SearchField = ({
  className,
  inputClassName,
  size = 'default',
  ...props
}: SearchFieldProps) => (
  <div className={[styles.root, styles[size], className].filter(Boolean).join(' ')}>
    <Search aria-hidden="true" className={styles.icon} size={16} />
    <input
      className={[styles.input, inputClassName].filter(Boolean).join(' ')}
      type="search"
      {...props}
    />
  </div>
)
